import React from 'react';
import { Container } from 'reactstrap';
import DataWrapper from '../../../principal/containers/DataWrapper';
import { inject, observer } from 'mobx-react';
import { FiltrosEstoque } from './../components/FiltrosEstoque';
import { ControleEstoqueStore } from '../stores/ControleEstoqueStore';
import TabelaEstoque from '../components/TabelaEstoque';
import JanelaFiltros from '../../../comum/components/JanelaFiltros';
import CamposEstoqueStore from '../stores/CamposEstoqueStore';
import Footer from '../../../comum/components/Footer';
import FooterOptions from '../../../comum/components/FooterOptions';
import IconButton from '../../../comum/components/IconButton';
import { makePDF } from './../../../../utils/formatar';
import ExportarExcelEstoque from './../components/ExportarExcelEstoque';

@inject("store")
@DataWrapper
@observer
export class ControleEstoque extends React.Component {

    constructor(props) {
        super(props);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.appStore = this.props.store.appStore;
        this.controller = new ControleEstoqueStore();
        this.camposStore = new CamposEstoqueStore();

        this.handleCancelFilter = this.handleCancelFilter.bind(this);
        this.handleClickFilter = this.handleClickFilter.bind(this);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Controle de Carga - Descarga");
        this.appStore.showTopbar(true);

        this.controller.listarClientes();
        this.controller.listarStatusBl();
    }

    componentWillUpdate() {
        this.tituloPaginaStore.setTitulo(!this.controller.mostrarCamposExibicao ? "Controle de Carga - Descarga" : "Customizar Visualização");
    }
    handleClickFilter() {
        this.camposStore.salvarFiltro();
        this.controller.fecharPagCampos(this.camposStore.filtrosSalvos[this.camposStore.filtroSelecionado]);
    }
    handleCancelFilter() {
        this.controller.fecharSemSalvar();
    }

    render() {
        
        const pdfData = this.controller.colunas;
        const pdfDataTime = pdfData.filter(elem => elem.formatter && elem.formatter.name === 'formatarDataCustomHTML')

        return(
            <React.Fragment>
                <div className="form-wrapper">
                        {
                            !this.controller.mostrarCamposExibicao
                            ?<Container className="agendamento" fluid>
                                <FiltrosEstoque controller={this.controller} />
                                <TabelaEstoque controller={this.controller} />
                            </Container>
                            :<JanelaFiltros
                                closeAction = {this.handleClickFilter}
                                cancelButAction = {this.handleCancelFilter}
                                controller = {this.camposStore}
                                fields = {['rowCards','checkbox']}
                                checkboxItems = {check}
                                rowCardsItems = {cards}
                                editName={false} //disabled for now
                                //editName = {this.camposStore.mudarNomePred}
                                showWarningModal = {false}
                            />
                        }
                    
                </div>
                {!this.controller.mostrarCamposExibicao && <Footer>
                    <FooterOptions>
                        <IconButton
                            icon="file-pdf"
                            text="Baixar PDF"
                            size="md"
                            disabled={this.controller.estoque.length <= 0}
                            onClick={
                                () => makePDF(
                                    this.controller.estoque,
                                    pdfData.map(elem => elem.dataField),
                                    pdfData.map(elem => elem.text),
                                    pdfDataTime.map(elem => elem.dataField),
                                    true,
                                    false
                                )
                            }
                        />
                        <ExportarExcelEstoque controller={this.controller} />
                    </FooterOptions>
                </Footer>}
            </React.Fragment>
        )
    }

}

const check = {
    titulo: "Dados da tabela",
    itens: "todosCampos",
    itensAtivos: "camposAtivos",
    itensRequeridos: "camposObrigatorios",
    onClickItem: "clickCheckboxCampo",
    selecionarTudo:"selecionarTodosOsCampos",
    limparTudo:"limparTodosOsCampos"
}

const cards = {
    titulo: "Predefinições",
    container: "filtrosSalvos",
    ativo: "filtroSelecionado",
    onClick: "clickFiltro",
    editarClick: "editarFiltroNomeClick",
    editCancel:"cancelarNovoNome",
    editSave: "salvarNovoNome",
    editLabels:[
        {
            label:"Nome",
            value:"nome",
            onChange:"mudarNomePred"
        },
        {
            label:"Descrição",
            value:"descricao",
            onChange:"mudarDescPred"
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modules/consultas/estoque/telas/ControleEstoque.js